export default __webpack_public_path__ + "static/media/jest.c22646ec.png";